import { gql, useQuery } from '@apollo/client'
import profileRequestOccasionsFragment from 'graphql/fragments/profileRequestOccasionsFragment'
import { currentMarketIdVar } from 'graphql/reactive'

export const useRequestOccasionsQuery = gql`
  query useRequestOccasionsQuery(
    $requestOccasionFirst: Int
    $marketId: ID!
    $productType: ParentProductType
  ) {
    market(id: $marketId) {
      id
      ...profileRequestOccasionsFragment
    }
  }
  ${profileRequestOccasionsFragment}
`

export default function useRequestOccasions({ productType, first = 25 }) {
  const marketId = currentMarketIdVar()

  const { loading, error, data } = useQuery(useRequestOccasionsQuery, {
    variables: { marketId, productType, requestOccasionFirst: first },
  })

  return {
    loading,
    error,
    requestOccasions: data?.market?.requestOccasions.edges.map(
      (edge) => edge.node,
    ),
  }
}
